module.exports = __webpack_public_path__ + "static/media/WITJSFTKC2.0879ec75.png";